import React, { useEffect } from 'react';
import styled from 'styled-components';
import {
  ExhibitionContainer,
  PageTitle,
  Byline,
  Paragraph,
  HeroImage,
  HeroCaption
} from '../../styles/exhibitionStyles';

const QuoteGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  margin: 30px 0 10px;
`;

const QuoteCard = styled.blockquote`
  margin: 0;
  padding: 24px;
  border-left: 3px solid #111;
  background: #f7f7f7;
  font-size: 28px;
  line-height: 1.2;
  font-style: italic;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export default function FabukMagazineReview() {
  useEffect(() => {
    document.title = "FabUK Magazine: London Exhibition Review - SLEEPR";
  }, []);

  return (
    <ExhibitionContainer>
      <HeroImage src="/img/magazine/fabuk-cover.jpg" alt="FabUK Magazine cover" />
      <HeroCaption>FabUK Magazine review of the London Secrets exhibition.</HeroCaption>

      <PageTitle>FabUK Magazine: London Exhibition Review</PageTitle>
      <Byline>
        FabUK recently reviewed the London Secrets exhibition with praise calling it a "..cultural wonder".
      </Byline>

      <QuoteGrid>
        <QuoteCard>“..in the case of Sleepr’s show last month we experienced a cultural wonder”</QuoteCard>
        <QuoteCard>“..a world reminiscent of Stanley Kubrick’s eyes wide shut”</QuoteCard>
        <QuoteCard>“..effortlessly drew us in and hooked our imagination.”</QuoteCard>
      </QuoteGrid>

      <Paragraph>
        The FabUK review recounts a theatrical evening at the Soho gallery, where visitors stepped into a masked, cinematic atmosphere that blurred performance and exhibition. The piece describes the show as a dramatic, immersive experience, from the cloaked figures to the live music and dimly lit rooms that intensified the sense of ritual.
      </Paragraph>
      <Paragraph>
        The article praises the scale and presence of the works, calling out the lighting design and the way the images unfolded in space. It highlights the mix of wonder and unease that underpinned the night, with each room revealing another layer of the exhibition’s narrative and mystery.
      </Paragraph>
      <Paragraph>
        Read the full review and extended interview here: <a href="/interviews/fabuk-magazine-the-secrets-show">FabUK Magazine: The Secrets Show</a>.
      </Paragraph>
    </ExhibitionContainer>
  );
}
